<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-03-21 13:38:28
-->
<template>
  <!-- 文件导入 -->
  <div class="upload_popup">
    <span @click="dialogFormVisible = true">
      <slot></slot>
    </span>
    <el-dialog
      title="文件上传操作"
      :visible.sync="dialogFormVisible"
    >
      <el-upload
        class="upload-demo"
        ref="upload"
        name="file"
        :action="url"
        :show-file-list="false"
        :http-request="uploadSectionFile"
      >
        <el-input
          disabled
          size="small"
          v-model="previewFile"
          placeholder="只能上传xls、xlsx文件"
        ></el-input>
        <el-button
          size="small"
          type="primary"
        >浏览</el-button>
      </el-upload>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="small"
          type="primary"
          @click="submitUpload"
        >上传</el-button>
        <el-button
          size="small"
          @click="dialogFormVisible = false"
        >取 消</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import axios from "axios";
import http from "../../axios/index";
import * as cookieServ from "@/utils/methods/cookie";
export default {
  name: "file-upload",
  props: {
    url: {
      type: String,
      default: () => {
        return "";
      },
    },
    uploadParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      previewFile: "",
      dialogFormVisible: false,
      file: null,
      full: "",
      headers: {
        Token: "",
        lang: "zh_CN",
      },
    };
  },
  computed: {},
  methods: {
    // 上传
    submitUpload() {
      // 根据后台需求数据格式
      const form = new FormData();
      // 文件对象
      form.append("file", this.file.file);
      console.log(form, this.file.file);
      http
        .postUpload(this.url, form)
        .then((res) => {
          //自行处理各种情况
          const code = res && parseInt(res.code, 10);
          if (code === 200) {
            // xxx
          } else {
            // xxx
          }
        })
        .catch(() => {
          // xxx
        });
    },
    uploadSectionFile(params) {
      console.log("file", params);
      const file = params.file,
        fileType = file.type,
        isExcel =
          file.name.indexOf(".xlsx") != -1 || file.name.indexOf(".xls") != -1;
      this.previewFile = file.name;
      if (!isExcel) {
        this.$message.error("只能上传文件格式xlsx、xls!");
        return;
      }
      this.file = params;
    },
  },
  components: {},
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
  },
  created() {
    this.full = axios.defaults.baseURL;
    this.headers.Token = cookieServ.getCookie("token");
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    // keyName: {
    // 注意：当观察的数据为对象或数组时，curVal和oldVal是相等的，因为这两个形参指向的是同一个数据对象
    // deep: true,
    //handler (curVal, oldVal) {
    // console.log(curVal, oldVal)
    //}
    // }
    dialogFormVisible: {
      handler(e) {
        if (!e) {
          this.previewFile = "";
          this.file = null;
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.upload_popup {
  color: initial;
  display: inline-block;

  /deep/.el-dialog__wrapper {
    > div {
      float: none;
      width: 400px;
    }
    .upload-demo {
      width: auto;
    }
    .el-dialog__body {
      margin-left: 0 !important;
      width: 100%;
      .el-input {
        margin-left: 16px !important;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #6b6c71;
        display: inline-block;
        width: 250px;
      }
      .el-input.is-disabled .el-input__inner {
        color: #696b70;
      }
      .el-button {
        display: inline-block;
        margin-left: 20px;
      }
    }
    .el-dialog__footer {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-left: 0 !important;
    }
    .el-upload-list {
      display: none;
    }
  }
}
</style>